import { effects as customersEffects } from './customers';
import { effects as customerEffects } from './customerDetails';
import { effects as overviewEffects } from './customerDetails/overview';
import { effects as receiptsEffects } from './customerDetails/receipts';
import { effects as receiptEffects } from './customerDetails/receipt';
import { effects as discountsEffects } from './customerDetails/discounts';
import { effects as addressesEffects } from './customerDetails/addresses';
import { effects as companyEffects } from './customerDetails/company';
import { effects as attributesEffects } from './customerDetails/attributes';

const effects = {
    ...customersEffects,
    ...customerEffects,
    ...overviewEffects,
    ...receiptsEffects,
    ...receiptEffects,
    ...discountsEffects,
    ...addressesEffects,
    ...companyEffects,
    ...attributesEffects,
};

export default effects;
